<div
	[formGroup]="formData"
	class="popup p-[36px] rounded-lg  max-mobile:py-[7px] max-mobile:px-[12px] {{
		reject && !accept ? 'relative h-[95%]' : ''
	}}"
>
	<div class="flex justify-between">
		<div></div>
		<p class="text-[18px] text-[#4E4B66] font-DIN-bold font-bold">
			{{ 'PAYOUT.PAYOUT_LIST.TRANSACTION' | translate }}
		</p>
		<div (click)="closeDialog()">
			<img
				class="ml-[100%] cursor-pointer"
				src="assets/images/close-square.svg"
				alt=""
			/>
		</div>
	</div>

	<div class="bg-grey-background mt-[25px] rounded-[12px]">
		<div class="w-full rounded-[3px] lg:flex gap-2">
			<div class="py-[8px] px-[24px] flex gap-[8px] w-full">
				<img
					class="h-[24px] w-[24px] my-auto"
					src="./assets/images/receipt-2.png"
					alt=""
					srcset=""
				/>

				<div>
					<p class="text-[#6E7191] text-[12px] mb-0">
						{{ 'PAYOUT.PAYOUT_LIST.PAYOUT_NUMBER' | translate }}
					</p>
					<p class="text-[#4E4B66] text-[16px] mb-0">{{ clientData?.id }}</p>
				</div>
			</div>

			<div class="py-[8px] px-[24px] flex gap-[8px] w-full">
				<img class="my-auto" src="./assets/images/user.svg" alt="" srcset="" />

				<div>
					<p class="text-[#6E7191] text-[12px] mb-0">
						{{ 'PAYOUT.PAYOUT_LIST.CLIENT_NAME' | translate }}
					</p>
					<p class="text-[#4E4B66] text-[16px] mb-0 whitespace-nowrap">
						{{ clientData?.clientName }}
					</p>
				</div>
			</div>
			<div class="py-[8px] px-[24px] flex gap-[8px] w-full">
				<img
					class="my-auto"
					src="./assets/images/calendar.svg"
					alt=""
					srcset=""
				/>

				<div>
					<p class="text-[#6E7191] text-[12px] mb-0">
						{{ 'PAYOUT.PAYOUT_LIST.REQUEST_DATE' | translate }}
					</p>
					<p class="text-[#4E4B66] text-[16px] mb-0 whitespace-nowrap">
						{{
							clientData?.requestDate | date : 'dd/MM/yyyy , hh:mm a' : 'UTC'
						}}
					</p>
				</div>
			</div>
			<div class="py-[8px] px-[24px] flex gap-[8px] w-full">
				<img
					class="h-[24px] w-[24px] my-auto"
					src="./assets/images/dollar-circle.png"
					alt=""
					srcset=""
				/>

				<div>
					<p class="text-[#6E7191] text-[12px] mb-0">
						{{ 'PAYOUT.PAYOUT_LIST.REQUEST_AMOUNT' | translate }}
					</p>
					<p class="text-[#4E4B66] text-[16px] mb-0">
						{{ clientData?.requestedAmount }}
						{{
							translate.currentLang === 'ar'
								? clientData.currency?.name?.ar
								: clientData.currency?.name?.en
						}}
					</p>
				</div>
			</div>
		</div>
		<hr class="w-full" />
		<div class="w-full rounded-[3px] lg:flex gap-2">
			<div
				class="py-[8px] px-[24px] flex gap-[8px] {{
					clientData?.payoutMethod?.id == 1 ? 'w-full' : 'w-[32%]'
				}}"
			>
				<img
					class="h-[24px] w-[24px] my-auto"
					src="./assets/images/bank.png"
					alt=""
					srcset=""
				/>

				<div>
					<p class="text-[#6E7191] text-[12px] mb-0">
						{{ 'PAYOUT.PAYOUT_LIST.PAYOUT_METHOD' | translate }}
					</p>
					<p class="text-[#4E4B66] text-[16px] mb-0">
						{{
							translate.currentLang === 'ar'
								? clientData?.payoutMethod?.nameAr
								: clientData?.payoutMethod?.nameEn
						}}
					</p>
				</div>
			</div>

			<div
				*ngIf="clientData?.payoutMethod?.id == 1"
				class="py-[8px] px-[24px] flex gap-[8px] w-full"
			>
				<img
					class="h-[24px] w-[24px] my-auto"
					src="./assets/images/bank.png"
					alt=""
					srcset=""
				/>

				<div>
					<p class="text-[#6E7191] text-[12px] mb-0">
						{{ 'PAYOUT.PAYOUT_LIST.BANK_NAME' | translate }}
					</p>
					<p class="text-[#4E4B66] text-[16px] mb-0 whitespace-nowrap">
						{{ clientData?.bankName }}
					</p>
				</div>
			</div>
			<div
				*ngIf="clientData?.payoutMethod?.id == 1"
				class="py-[8px] px-[24px] flex gap-[8px] w-full"
			>
				<img
					class="my-auto"
					src="./assets/images/receipt-2.png"
					alt=""
					srcset=""
				/>

				<div>
					<p class="text-[#6E7191] text-[12px] mb-0">
						{{ 'PAYOUT.PAYOUT_LIST.ACC_NUMBER' | translate }}
					</p>
					<p class="text-[#4E4B66] text-[16px] mb-0 whitespace-nowrap">
						{{ clientData?.accountNumber }}
					</p>
				</div>
			</div>
			<div
				*ngIf="clientData?.payoutMethod?.id == 1"
				class="py-[8px] px-[24px] flex gap-[8px] w-full"
			>
				<img
					class="h-[24px] w-[24px] my-auto"
					src="./assets/images/bank.png"
					alt=""
					srcset=""
				/>

				<div>
					<p class="text-[#6E7191] text-[12px] mb-0">
						{{ 'PAYOUT.PAYOUT_LIST.ACC_NAME' | translate }}
					</p>
					<p class="text-[#4E4B66] text-[16px] mb-0">
						{{ clientData?.accountName }}
					</p>
				</div>
			</div>

			<div
				*ngIf="clientData?.payoutMethod?.id == 2"
				class="py-[8px] px-[24px] flex gap-[8px] w-full"
			>
				<img
					class="h-[24px] w-[24px] my-auto"
					src="./assets/images/receipt-2.png"
					alt=""
					srcset=""
				/>

				<div>
					<p class="text-[#6E7191] text-[12px] mb-0">
						{{ 'PAYOUT.PAYOUT_LIST.FAWRY_ACC_NUMBER' | translate }}
					</p>
					<p class="text-[#4E4B66] text-[16px] mb-0">
						{{ clientData?.fawryAccount }}
					</p>
				</div>
			</div>

			<div
				*ngIf="clientData?.payoutMethod?.id == 3"
				class="py-[8px] px-[24px] flex gap-[8px] w-full"
			>
				<img
					class="h-[24px] w-[24px] my-auto"
					src="./assets/images/receipt-2.png"
					alt=""
					srcset=""
				/>

				<div>
					<p class="text-[#6E7191] text-[12px] mb-0">
						{{ 'PAYOUT.PAYOUT_LIST.INSTA_ID' | translate }}
					</p>
					<p class="text-[#4E4B66] text-[16px] mb-0">
						{{ clientData?.instapayAccount }}
					</p>
				</div>
			</div>
		</div>
	</div>
	<div class="bg-grey-background mt-[24px] rounded-[12px] p-[36px]">
		<div
			class="max-w-[406px] text-center m-auto flex justify-center items-center py-[8px] px-[10px] bg-off-white rounded-[50px] text-dark-grey mt-[18px] mb-24px text-font-16 cursor-pointer border-secondry-color-Gray border-[1px]"
		>
			<a
				class="text-center w-[55%] max-mobile:text-font-mobile-small {{
					accept ? 'activeClass' : ''
				}}"
				(click)="
					reject = false;
					accept = true;
					onChange();
					getController('notes').reset()
				"
			>
				{{ 'ACTIONS.ACCEPT' | translate }}
			</a>
			<a
				class="text-center w-[55%] max-mobile:text-font-mobile-small {{
					reject ? 'activeClass' : ''
				}}"
				(click)="
					reject = true;
					accept = false;
					onChange();
					getController('notes').reset();
					getController('image').reset()
				"
			>
				{{ 'ACTIONS.REJECT' | translate }}
			</a>
		</div>
		<div class="mt-[24px]" *ngIf="!reject">
			<mat-form-field class="w-full mb-24px relative" appearance="outline">
				<mat-label> {{ 'GENERAL_LABELS.AMOUNT' | translate }} </mat-label>
				<input
					matInput
					autofocus="false"
					class="text-dark-grey"
					formControlName="amount"
					type="number"
					required
				/>
				<p class="text-dark-grey absolute ltr:right-1 rtl:left-1 top-4">
					/{{
						translate.currentLang === 'ar'
							? clientData.currency?.name?.ar
							: clientData.currency?.name?.en
					}}
				</p>
			</mat-form-field>
		</div>
		<div
			*ngIf="!reject"
			class="py-[16px] {{
				getController('image')?.value ? '' : 'border-custom'
			}} border-[#D9DBE9] my-[12px] relative"
		>
			<div
				class="min-h-[149px] rounded-[6px] border-[#D9DBE9] flex justify-center items-center mx-auto"
			>
				<button (click)="uploadImage()" class="custom-btn relative">
					<label class="cursor-pointer border-[#D9DBE9]">
						<img
							class="m-auto rounded-[6px]"
							[src]="
								getController('image')?.value
									? attachmentUrl + getController('image')?.value
									: './assets/images/upload.svg'
							"
							alt=""
						/>

						<h1
							*ngIf="getController('image')?.value == null"
							class="text-[#007AFF] mt-[6px] text-font-16 font-normal leading-[24px] m-0"
						>
							{{ 'ACTIONS.UPLOAD_IMG' | translate }}
							<span class="text-gradient"> * </span>
						</h1>
						<p
							*ngIf="getController('image')?.value == null"
							class="text-[#6E7191] text-[14px]"
						>
							{{ 'PAYOUT.PAYOUT_LIST.VISIBLE_AT_CLIENT' | translate }}
						</p>
					</label>
					<button
						class="absolute bottom-3 ltr:right-3 rtl:left-3"
						(click)="$event.stopPropagation(); getController('image')?.reset()"
					>
						<img
							*ngIf="getController('image')?.value"
							class="bg-white rounded-full p-2 w-9"
							src="assets/images/delete.svg"
							alt=""
						/>
					</button>
				</button>
			</div>
		</div>
		<div class="mt-[24px] h-[65px]">
			<mat-form-field
				[dir]="translate.currentLang == 'ar' ? 'rtl' : 'ltr'"
				class="w-full mb-24px"
				appearance="outline"
			>
				<mat-label>
					{{ 'GENERAL_LABELS.NOTES' | translate }}
					{{ 'PAYOUT.PAYOUT_LIST.VISIBLE_AT_CLIENT' | translate }}</mat-label
				>
				<input
					matInput
					class="text-dark-grey reason"
					formControlName="notes"
					type="text"
					maxlength="500"
					autofocus="false"
				/>
				<mat-error>
					<validation-message
						[controller]="getController('notes')"
						controller_name="GENERAL_LABELS.NOTES"
					>
					</validation-message>
				</mat-error>
			</mat-form-field>
		</div>
	</div>

	<div
		class="text-center {{
			reject && !accept ? 'w-[93%] absolute bottom-1' : ''
		}} "
	>
		<button
			(click)="confirm()"
			[disabled]="formData.invalid"
			class="w-full mt-3 bg-gradient text-white"
			mat-button
		>
			{{ 'ACTIONS.SUBMIT' | translate }}
		</button>
		<button
			class="w-full mt-3 text-medium-gray bg-transparent rounded-[6px] border-[#D9DBE9] border-[1px] border-solid"
			mat-button
			(click)="
				closeDialog();
				getController('notes').reset();
				getController('image').reset()
			"
		>
			{{ 'ACTIONS.CANCEL' | translate }}
		</button>
	</div>
</div>
